export * from './directives/detect-color.directive'
export * from './sp-avatar.component';
